@let _canPan = host?.canPan() || false;

<button
	class="ada-btn ada-full-width"
	data-testid="ada-viewbox-control-pan-toggle-btn"
	[ngClass]="_canPan ? 'toggle-btn-color' : 'ada-btn-outline'"
	(click)="togglePan()"
>
	<ada-icon
		class="icon"
		[color]="_canPan ? 'background' : 'foreground'"
		[icon]="_canPan ? 'faHand' : 'faHandOutline'"
	/>
	Pan
</button>
<div class="ada-display-flex ada-flex-align-center ada-flex-justify-between zoom-controls">
	<button
		class="ada-btn ada-btn-outline"
		data-testid="ada-viewbox-control-zoom-in-btn"
		(click)="zoomIn()"
	>
		<ada-icon
			color="foreground"
			icon="faPlus"
		/>
	</button>
	<span class="zoom-value">{{ host.z() * 100 | number: '1.0-0' }}%</span>
	<button
		class="ada-btn ada-btn-outline"
		data-testid="ada-viewbox-control-zoom-out-btn"
		(click)="zoomOut()"
	>
		<ada-icon
			color="foreground"
			icon="faMinus"
		/>
	</button>
</div>
<button
	class="ada-btn ada-btn-outline ada-full-width"
	data-testid="ada-viewbox-control-reset-btn"
	(click)="resetView()"
>
	Reset View
</button>
